var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloudDownload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "download",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.443,
    height: 22,
    viewBox: "0 0 23.443 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_34166",
    "data-name": "Path 34166",
    d: "M18.931,5.9a7.335,7.335,0,0,0-14.385,0,5.134,5.134,0,0,0,.591,10.235H8.8a.733.733,0,1,0,0-1.467H5.137A3.667,3.667,0,1,1,5.18,7.331a.733.733,0,0,0,.729-.653,5.868,5.868,0,0,1,11.657,0,.777.777,0,0,0,.772.653,3.667,3.667,0,1,1,0,7.335H14.672a.733.733,0,1,0,0,1.467h3.667A5.134,5.134,0,0,0,18.931,5.9Zm0,0",
    transform: "translate(0.001 0)",
    fill: "#39be9d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34167",
    "data-name": "Path 34167",
    d: "M178.67,216.277l-1.859,1.86v-9.231a.733.733,0,1,0-1.467,0v9.231l-1.859-1.86a.733.733,0,1,0-1.055,1.019l.018.018,3.111,3.111a.735.735,0,0,0,.237.158.725.725,0,0,0,.565,0,.732.732,0,0,0,.237-.158l3.111-3.111a.733.733,0,1,0-1.019-1.055Zm0,0",
    transform: "translate(-164.338 -198.641)",
    fill: "#39be9d"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudDownload);
export default __webpack_public_path__ + "static/media/cloud-download.295fe841e83f15d3622dbe85304e65ef.svg";
export { ForwardRef as ReactComponent };